import Vue from "vue"

// Lib imports
import Axios from "axios"

Vue.prototype.$http = Axios

const token = localStorage.getItem("jwt")
if (token) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] = token
}
